
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.232.48a5.859 5.859 0 00-4.085 1.753A5.664 5.664 0 00.48 6.34 5.654 5.654 0 006.144 12h.103A5.813 5.813 0 0012 6.14 5.648 5.648 0 006.232.48zM5.52 8.42a.708.708 0 01.696-.734h.013c.393 0 .716.312.73.705a.708.708 0 01-.695.735h-.013a.734.734 0 01-.73-.706zm.24-4.82v2.88a.48.48 0 10.96 0V3.6a.48.48 0 00-.96 0z","fill":"#FF3867"}})])
          )
        }
      }
    